import { EnumLikeAsConst } from "../../../helper-services/enum-like-as-const";

const None = 0b0;
const Disabled = 0b10;
const Enabled = 0b11;
const FlagDisabled = 0b110;
const FlagEnabled = 0b111;

type DefaultFlagValueEntries =
  | typeof None
  | typeof Disabled
  | typeof Enabled
  | typeof FlagDisabled
  | typeof FlagEnabled;
// handwritten to break circular ref.
export type DefaultFlagValue = DefaultFlagValueEntries | ((v: DefaultFlagValueEntries) => boolean);

export const DefaultFlagValue = {
  None: None,
  Disabled: Disabled,
  Enabled: Enabled,
  FlagDisabled: FlagDisabled,
  FlagEnabled: FlagEnabled,

  is: (v: DefaultFlagValue): boolean => Object.values(DefaultFlagValue).includes(v),
  isNone: (v: DefaultFlagValue): boolean => v === None,
  isEnabled: (v: DefaultFlagValue): boolean => v === FlagEnabled || v === Enabled,
  isDisabled: (v: DefaultFlagValue): boolean => v === FlagDisabled || v === Disabled,
  isDefault: (v: DefaultFlagValue): boolean => v === FlagDisabled || v === FlagEnabled,
  isPristine: (v: DefaultFlagValue): boolean =>
    v === None || v === FlagDisabled || v === FlagEnabled,
  isTouched: (v: DefaultFlagValue): boolean => v === Disabled || v === Enabled,

  ...EnumLikeAsConst.stub<DefaultFlagValue>(),
} as const;

EnumLikeAsConst.define(DefaultFlagValue, "DefaultFlagValue");
